import { render, staticRenderFns } from "./RestauranteSabores.vue?vue&type=template&id=52beca7b&scoped=true"
import script from "./RestauranteSabores.vue?vue&type=script&lang=js"
export * from "./RestauranteSabores.vue?vue&type=script&lang=js"
import style0 from "./RestauranteSabores.vue?vue&type=style&index=0&id=52beca7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52beca7b",
  null
  
)

export default component.exports